var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    stroke: "#ededed",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.92969 11.248H6.92969C5.60361 11.248 4.33184 11.7397 3.39415 12.6149C2.45647 13.4901 1.92969 14.677 1.92969 15.9147H14.9297C14.9297 15.3019 14.8004 14.695 14.5491 14.1289C14.2978 13.5627 13.9295 13.0482 13.4652 12.6149C13.0009 12.1815 12.4497 11.8378 11.8431 11.6033C11.2365 11.3688 10.5863 11.248 9.92969 11.248V11.248Z",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42969 8.4474C10.3627 8.4474 11.9297 6.98486 11.9297 5.18073C11.9297 3.3766 10.3627 1.91406 8.42969 1.91406C6.49669 1.91406 4.92969 3.3766 4.92969 5.18073C4.92969 6.98486 6.49669 8.4474 8.42969 8.4474Z",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.e9907933.svg";
export { ForwardRef as ReactComponent };